// extracted by mini-css-extract-plugin
export default {"goBack":"BackButton_goBack__dCTch","goBackImage":"BackButton_goBackImage__6yPmk","goBackText":"BackButton_goBackText__uiDaw"};